module.exports = __webpack_public_path__ + "static/media/bg_signin.ef01ffe9.png";